export default {"src":"/_next/static/media/resume-sip.ef42fd53.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};